import { useSearchParams } from 'react-router-dom';

// Dev-only override: `?decoration=<id>` in the URL applies the decoration
// to the current user's row. Backend will replace this with a real field
// on the user/entry once the inventory system is ready.
export const useDevDecoration = (): string | undefined => {
  const [searchParams] = useSearchParams();

  return searchParams.get('decoration') ?? undefined;
};
